import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { ErrorsService, SALVAR } from '../errors/errors.service';
import { URL_API } from '../../tools/URL';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LaiService {

  constructor(
    private rest: RestService,
    private errorsService: ErrorsService
  ) {}

  carregarPorId(id: number) {
    return this.rest.get(`${URL_API.PATH_LAI}/${id}`);
  }

  enviar(registro: {}) {
    return this.rest.post(`${URL_API.PATH_LAI}/enviar`, registro).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  salvar(registro: {}, enviar: boolean = true) {
    if (enviar) {
      return this.rest.post(`${URL_API.PATH_LAI}/enviar`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }

    return this.rest.post(`${URL_API.PATH_LAI}/salvar`, registro).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  atualizar(id: number, registro: {}, enviar: boolean = true) {
    if (enviar) {
      return this.rest.put(`${URL_API.PATH_LAI}/enviar/${id}`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }

    return this.rest.put(`${URL_API.PATH_LAI}/salvar/${id}`, registro).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }
}
